import { Greyscale } from 'glints-aries';
import { LinkResolver } from 'nextDir/modules/Router/Link';
import styled from 'styled-components';

import { GhostBtnStyle } from '../../components/buttons';
import { device } from '../../components/screenSize';

export const GhostBtnExt = styled(LinkResolver)`
  ${GhostBtnStyle}
  padding: 0.4em 0.6em;
  margin-left: 4em;
  border: none;
  background-color: ${Greyscale.white};
`;

export const SignUpContainer = styled.section`
  position: relative;
  display: block;
`;

export const SignUpWrapper = styled.div`
  position: relative;
  background-color: ${Greyscale.white};
  margin: 10em auto auto;
  z-index: 0;
`;

export const SignUpFormWrapper = styled.div`
  padding: 1em 2em;
`;

export const SignUpTwoCols = styled.div`
  display: grid;
  grid-template-columns: 100%;

  @media ${device.tablet} {
    grid-template-columns: 50% 50%;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em;
`;

export const SubmitWrapper = styled.div<{ display?: string }>`
  display: ${({ display }) => display ?? 'initial'};
  position: relative;
  padding: 1em;

  > span {
    display: block;
    text-align: center;
    margin-bottom: 1em;
    color: ${Greyscale.grey};
    font-size: 13px;
    font-weight: 300;
  }
`;

export const BtnSubmit = styled.button`
  width: 100%;
  margin: 2em auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #017eb8;
  border: none;
  font-weight: 600;
  color: ${Greyscale.white};
  text-transform: uppercase;
  padding: 1em;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  @media ${device.tablet} {
    width: 50%;
  }

  p {
    flex: 1;
    letter-spacing: 0.6px;
  }
`;

export const LoginWithSocialMedia = styled.div`
  text-align: center;
  color: ${Greyscale.grey};
  font-weight: 300;
  a {
    color: ${Greyscale.black};
  }

  &:after {
    position: relative;
    margin-top: 1em;
    margin-bottom: 1em;
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #fafafa;
  }
`;

export const TermsWrapper = styled.div`
  margin-top: 1em;
  line-height: 2;
  font-size: 13px;
`;

export const AlreadyHaveAccount = styled.div`
  display: flex;
  justify-content: center;

  label {
    align-self: center;
    color: ${Greyscale.grey};
  }
`;
